import ko from 'knockout'
// js计算时精度问题引入number-precision
import NP from 'number-precision'
import Base from '../../core/base'
import {
  gridRefMixin,
  changeStyleMixin
} from '../../mixin'
import {
  isInteger,
  isPositiveInteger,
  isPositivenumber
} from '../../util/formatFunc'
import {toThousands} from '@/components/grid/gridutil.js'
import tippy from 'tippy.js';
const _INTERGER = 'integer'
const _POSITIVEINTEGER = 'positiveinteger'
const _POSITIVENUMBER = 'positivenumber'
const _CUSTOMTYPELIST = [_INTERGER, _POSITIVEINTEGER, _POSITIVENUMBER]
class Input extends Base {
  initialize (params) {
    this.value = params.value || ko.observable()
    this.size = params.size || 'md'
    this.placeholder = params.placeholder || ''
    this.prepend = params.prepend || false
    this.append = params.append || false
    this.fieldid = params.fieldid || this.value._fieldid || ''
    // 是否支持可清楚
    this.clearable = params.clearable || false
    this.align = params.align || 'left'
    this.isHasForm = !!params.onSubmit
    this.handleSubmit = params.onSubmit || function () { }
    this.handleIconClick = params.onIconClick || function () { }
    this.iconClass = params.iconClass || ''
    this.precision = params.precision
    this.disabled = params.disabled || ko.observable(false)
    // positiveinteger 是否包含0
    this.inCludeZero = params.inCludeZero || false
    // thousands为千分位格式
    this.formatter = params.formatter
    this.thousandsShow = ko.observable(this.formatter === 'thousands')
    gridRefMixin.call(this, params)
    // implement for aira grid
    this.setFocus = () => {
      var el = this.$el.querySelector('input')
      el.click()
      setTimeout(function () {
        el.select()
      })
    }
    this.typeList = [
      'text',
      'textarea',
      'password',
      'url',
      'email',
      'date',
      'number'
    ]
    this.maxlength = params.maxlength || 250
    this.required = params.required || false
    changeStyleMixin.call(this, params)
  }
  computed (params) {
    // this.ctnClass = params.class || ''
    this.ctnClass = ko.computed(() => {
      var _ctnClass = ''
      if (params.class) {
        _ctnClass = params.class
      }
      // 确保只支持计算属性
      if (params.computedCls) {
        _ctnClass += ' ' + params.computedCls()
      }
      _ctnClass += ' y-input-' + this.size
      var needRequired = false
      // 支持requrei传入ko对象同
      if (ko.isObservable(this.required)) {
        needRequired = this.required()
      } else {
        needRequired = this.required
      }
      if (needRequired) {
        if (ko.isObservable(this.value)) {
          var _value = this.value()
          // 如果输入值为空
          if (_value === undefined || _value === null || _value === '') {
            _ctnClass += ' y-input-required'
          }
        }
      }
      return _ctnClass
    })
    this.type = ko.computed(() => {
      if (params.type && this.typeList.indexOf(params.type) > -1) {
        return params.type
      } else {
        // 如果要求输入整数、正整数，正数
        return 'text'
      }
    })
    this.showIcon = ko.computed(() => {
      return this.iconClass.length > 0
    })
    this.thousandsVal = ko.computed(() => {
      if (this.formatter === 'thousands') {
        let precision = ko.unwrap(this.precision)
        if (!this.value() && this.value() !== 0) {
          this.thousandsShow(false)
          return ''
        }
        var value = parseFloat(this.value())
        value = value.toFixed(precision)
        return toThousands(value, true)
      } else {
        return ''
      }
    });
  }
  methods (params) {
    // 输入删除
    this.handleClose = () => {
      if (ko.isObservable(this.value)) {
        this.value('')
      } else {
        this.value = ''
      }
    }

    // 默认校验
    this.defaultValidate = (vm, e) => {
      if (_CUSTOMTYPELIST.indexOf(params.type) > -1) {
        switch (params.type) {
          case _INTERGER:
            return isInteger.call(this, 'input')
          case _POSITIVEINTEGER:
            return isPositiveInteger.call(this, 'input')
          case _POSITIVENUMBER:
            return isPositivenumber.call(this, 'input')
        }
      } else {
        return true
      }
    }
    this.onKeyup =
      params.onKeyup ||
      function () {
        this.defaultValidate()
      }.bind(this)
    this.onChange = params.onChange || function () { }
    this.onInput = function (vm, e) {
      this.defaultValidate()
      // 4.1.26增加精度处理
      if (this.precision !== undefined) {
        let precision = ko.unwrap(this.precision)
        // 处理小数点后为0,10,100等时不能输入的情况调整
        let arr = [];
        // 根据.拆分value值
        arr = (e.target.value + '').split('.')
        // 小数点后输入位数h大于precision值时做一下截取处理
        if (arr[1]) {
          if (arr[1].length >= precision) {
            arr[1] = arr[1].slice(0, precision)
            e.target.value = arr[0] + '.' + arr[1]
          }
        }
        // 最后一位为0到时候不做处理，不然会导致e.target.value的值抹零
        if (e.target.value.charAt(e.target.value.length - 1) === "0") {
          if (arr[1]) {
            if (arr[1].length >= precision) {
              arr[1] = arr[1].slice(0, precision)
            }
            e.target.value = arr[0] + '.' + arr[1]
            return
          }
        }
        // 整数不做处理
        if (!isNaN(e.target.value) && e.target.value !== '' && e.target.value % 1 !== 0) {
          if (!isNaN(precision)) {
            let rate = Math.pow(10, precision)
            let rideValue = NP.times(e.target.value, rate)
            e.target.value = NP.divide(Math.floor(rideValue), rate)
          }
        }
      }
      params.onInput && params.onInput(e)
      if (this.enableChangingStyle) {
        if (String(this.oldValue) !== String(e.target.value)) {
          this.textChanged(true)
        } else {
          this.textChanged(false)
        }
      }
    }.bind(this)
    this.onBlur = function (e) {
      if (params.formatter === "thousands") {
        // 光标脱离输入框
        // 金额输入框或者不为空进行
        if (!params.value() && params.value() !== 0) {
          return
        }
        this.thousandsShow(true)
      }
      if (params.onBlur) {
        params.onBlur(e)
      }
    }
    this.onThousandsShowClick = () => {
      if (ko.unwrap(this.disabled)) {
        return
      }
      this.thousandsShow(false)
      this.$el.querySelector('input').focus()
    }
    ko.tasks.schedule(() => {
      if (params.tipContent) {
        this.tippyInstance = tippy(this.$el.querySelector('input'), {allowHTML: true, theme: 'light', placement: 'bottom'})
        var content = params.tipContent()
        this.tippyInstance.setContent(content)
      }
    })
    let that = this
    const tippyShow = () => {
      if (that.tippyInstance) {
        var content = params.tipContent()
        that.tippyInstance.setContent(content)
        that.tippyInstance.show()
      }
    }
    this.onFocus = function (e) {
      if (params.tipContent) {
        tippyShow()
      }
      if (params.formatter === "thousands") {
        // 金额输入框或者不为空进行
        if (!params.value()) {
          return
        }
        this.thousandsShow(false)
      }
      if (params.onFocus) {
        params.onFocus(e)
      }
    }
    this.onClick = function () {
      if (params.tipContent) {
        tippyShow()
      }
      return false
    }
  }
}
export default Input



// WEBPACK FOOTER //
// ./src/components/input/base.js